import React, { useState  } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector, FieldArray } from "redux-form";
import {
    renderField,
    renderTextArea,
    renderNumber,
    renderCurrency,
    renderPorcentaje,
} from "../../../Utils/renderField/renderField";
import { RenderCurrency as RCurrency } from "Utils/renderField/renderReadField";
import { Link } from "react-router-dom";
import { icons } from "icons";
import { preciosSucursal } from "../../camposProducto";
import { inventarioInicialFields } from "../../camposInventario"; 


import SettingToggle from "../../../../components/Utils/Ayuda/SettingToggle";
import ModalVideo from "../../../../components/Utils/Ayuda/ModalVideo";


const prodGrande = require("../../../../../../assets/img/icons/producto-grande.png");
const prodFraccion = require("../../../../../../assets/img/icons/producto-fraccion.png");

const estructuraDatos = {
    nombre: "",
    capacidad_maxima: 1,
    opcion: "grande",
    precio: "",
    precio2: "",
    precio3: "",
    precio4: "",
    precio5: "",
    codigos_barras: [],
    minimo_existencias: "",
    vendible: false,
    alertar: false,
    precios_sucursal: [],
};

const validate = (values) => {
    const errors = {};
    if (!values.nombre) errors.nombre = "Campo requerido";

    if (!values.precio) errors.precio = "Campo requerido";

    if (!values.opcion) errors.opcion = "Campo requerido";

    // if(!values.opcion) {
    //     if(!values.precio)
    //         errors.precio = 'Campo requerido';

    if (values.descripcion_codigo_barras) {
        if (values.descripcion_codigo_barras.length > 20)
            errors.descripcion_codigo_barras =
                "Debe tener 20 caracteres o menos.";
    }
    if (values.alertar) {
        if (!values.minimo_existencias)
            errors.minimo_existencias = "Campo requerido";
    }
    if (values.precios_sucursal) {
        if (values.precios_sucursal.length) {
            const preciosSucursalArrayErrors = [];
            values.precios_sucursal.forEach((precio_sucursal, index) => {
                const precioSucursalErrors = {};
                if (!precio_sucursal["precio"])
                    precioSucursalErrors.precio = "Campo requerido";
                preciosSucursalArrayErrors[index] = precioSucursalErrors;
            });

            if (preciosSucursalArrayErrors.length)
                errors.precios_sucursal = preciosSucursalArrayErrors;
        }
    }
    if (values.codigos_barras && values.codigos_barras.length > 0) {
        const codigosBarrasArrayErrors = [];
        const codigosVistos = new Set();
        
        values.codigos_barras.forEach((name, index) => {
            const codigoErrors = {};
            
            if (name.codigo) {
                const codigo = name.codigo.trim();
              
                if (!/^\w+$/i.test(codigo)) {
                  codigoErrors.codigo = "Debe contener solo letras y/o números.";
                  codigosBarrasArrayErrors[index] = codigoErrors;
                } else if (codigosVistos.has(codigo)) {
                  codigoErrors.codigo = "Este código ya existe en la lista. No se permiten duplicados.";
                  codigosBarrasArrayErrors[index] = codigoErrors;
                } else {
                  codigosVistos.add(codigo);
                }
              }
        });
        
        if (codigosBarrasArrayErrors.length) {
            errors.codigos_barras = codigosBarrasArrayErrors;
        }
    }

    return errors;
};



const renderCodigosBarras = ({ fields }) => {
    React.useEffect(() => {
        if (fields.length === 0) {
            fields.push('');
        }
    }, [fields]);

    return (
        <div>
            {fields.map((name, index) => (
                <div key={index} className="form-group d-flex align-items-center">
                    <Field
                        name={`${name}.codigo`}
                        component={renderField}
                        type="text"
                        className="form-control me-2"
                        placeholder="Ingrese código de barras"
                    />
                    {index === 0 ? (
                        <button
                            type="button"
                            className="btn d-flex btn-no-shadow justify-content-center align-items-center"
                            onClick={() => fields.push("")}
                        >
                            <img
                                src={require("../../../../../../assets/img/icons/agregar.png")}
                                alt="Agregar"
                            />
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-no-shadow justify-content-center align-items-center"
                            onClick={() => fields.remove(index)}
                        >
                            <img
                                src={require("../../../../../../assets/img/icons/eliminar.png")}
                                alt="Eliminar"
                            />
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};



const AccordionItem = ({ id, title, children, defaultOpen = false }) => {
    var collapseId = "collapse-" + id;
    var headingId = "heading-" + id;

    return (
        <div className="accordion-custom" style={{ marginBottom: '2px' }}>
            <div className="accordion-item" style={{ border: 'none' }}>
                <h2 className="accordion-header" id={headingId}>
                    <button
                        className={"accordion-button " + (defaultOpen ? "" : "collapsed")}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#" + collapseId}
                        onClick={function() {
                            var el = document.getElementById(collapseId);
                            if (el.classList.contains('show')) {
                                el.classList.remove('show');
                            } else {
                                el.classList.add('show');
                            }
                        }}
                        style={{
                            width: '100%',
                            textAlign: 'left',
                            backgroundColor: '#f2f2f2', // Gris claro exacto
                            border: 'none',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            color: '#444', // Texto oscuro pero no negro puro
                            fontSize: '14px', // Título grande como en la imagen
                            fontWeight: '300'
                        }}
                    >
                        {title}
                        <span style={{ fontSize: '10px', color: '#666' }}>▼</span>
                    </button>
                </h2>
                <div
                    id={collapseId}
                    className={"accordion-collapse collapse " + (defaultOpen ? "show" : "")}
                >
                    <div 
                        className="accordion-body" 
                        style={{ 
                            padding: '20px', 
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #eee' 
                        }}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

const renderStaticCurrency = ({ input, className }) => (
    <input
        {...input} // Importante: Pasa el valor actual (value) del estado de Redux
        type="text"
        className={className}
        disabled={true} // Deshabilita la interacción HTML
        readOnly={true} // Refuerza la solo lectura
        style={{
            backgroundColor: '#e9ecef', // Color gris estándar de Bootstrap para disabled
            cursor: 'not-allowed',
            color: '#495057',
            borderColor: '#ced4da'
        }}
    />
);

const DatosFraccion = (props) => {
    //  state
    const {
        alertarValue,
        editCreateFraccion,
        nombreValue,
        sucursales,
        sucursal,
        sucursal_activo,
        nombres_precios,
        conf_porcentaje_precio,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
    } = props;

    //  bind
    const {
        changeSucursal,
        changeSucursalActivo,
        cambioPorcentajePrecio,
    } = props;

    // Detectar si estamos en la pantalla real de editar producto
    const isProductoEdit = window.location.hash.includes('/productos/editar/');

    const renderStaticField = ({ input }) => (
        <input
            {...input}
            className="form-control"
            disabled
        />
    );


    //Soporte de videos
    const [videos, setVideos] = useState(null);
        
    const openVideoModal = function(videos){
        setVideos(videos);
    };
        
    const closeVideoModal = function(){
        setVideos(null);
    };

    return (
        <form>

            <AccordionItem id="datos-generales" title="Datos generales" defaultOpen>
                <div className="row row-fields">
                    <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                        <label htmlFor="nombre">Nombre *</label>
                        <Field
                            name="nombre"
                            component={renderField}
                            type="text"
                            className="form-control"
                        />
                    </div>
                    

                    <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                    <label htmlFor="codigos_barras">código de barras</label>
                    <FieldArray
                        name="codigos_barras"
                        component={
                            renderCodigosBarras
                        }
                    />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                        <label htmlFor="descripcion_codigo_barras">
                            Descripción código de barras
                        </label>
                        <Field
                            name="descripcion_codigo_barras"
                            component={renderField}
                            type="text"
                            className="form-control"
                        />
                    </div>
                </div>
            </AccordionItem>



            {!isProductoEdit && (
                <AccordionItem id="inventario-inicial" title="Inventario inicial por sucursal">
                    <div className="row row-fields">
                        <div className="col-12 col-md-12 col-lg-12 form-group">
                            <label>Inventario inicial</label>
                            <FieldArray
                                name="inventario_inicial"
                                component={inventarioInicialFields}
                                sucursales={sucursales}
                            />
                        </div>
                    </div>
                </AccordionItem>
            )}


            
            <AccordionItem id="precios-generales" title="Precios generales">
                <div className="row row-fields">
                    <div className="col-12 form-group mb-1 mt-3">
                        <label htmlFor="precio">Precios generales</label>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 form-group">
                        {nombres_precios ? (
                            <label htmlFor="precio">
                                {nombres_precios.nombre_precio} *
                            </label>
                        ) : (
                            <label htmlFor="precio">Precio normal *</label>
                        )}
                        <Field
                            name="precio"
                            component={renderCurrency}
                            decimalScale={2}
                            type="text"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio(
                                        "porcent_precio2",
                                        "FraccionCrear"
                                    );
                                    cambioPorcentajePrecio(
                                        "porcent_precio3",
                                        "FraccionCrear"
                                    );
                                    cambioPorcentajePrecio(
                                        "porcent_precio4",
                                        "FraccionCrear"
                                    );
                                    cambioPorcentajePrecio(
                                        "porcent_precio5",
                                        "FraccionCrear"
                                    );
                                });
                            }}
                        />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 form-group">
                        {nombres_precios ? (
                            <label htmlFor="precio2">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                {nombres_precios.nombre_precio2}
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio2Value
                                                    ? parseFloat(precio2Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        ) : (
                            <label htmlFor="precio2">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                Precio 2
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio2Value
                                                    ? parseFloat(precio2Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        )}
                        {conf_porcentaje_precio ? (
                            <Field
                                name="porcent_precio2"
                                component={renderPorcentaje}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "porcent_precio2",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        ) : (
                            <Field
                                name="precio2"
                                component={renderCurrency}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "precio2",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        )}
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 form-group">
                        {nombres_precios ? (
                            <label htmlFor="precio3">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                {nombres_precios.nombre_precio3}
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio3Value
                                                    ? parseFloat(precio3Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        ) : (
                            <label htmlFor="precio3">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                Precio 3
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio3Value
                                                    ? parseFloat(precio3Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        )}
                        {conf_porcentaje_precio ? (
                            <Field
                                name="porcent_precio3"
                                component={renderPorcentaje}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "porcent_precio3",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        ) : (
                            <Field
                                name="precio3"
                                component={renderCurrency}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "precio3",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        )}
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 form-group">
                        {nombres_precios ? (
                            <label htmlFor="precio4">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                {nombres_precios.nombre_precio4}
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio4Value
                                                    ? parseFloat(precio4Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        ) : (
                            <label htmlFor="precio4">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                Precio 4
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio4Value
                                                    ? parseFloat(precio4Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        )}
                        {conf_porcentaje_precio ? (
                            <Field
                                name="porcent_precio4"
                                component={renderPorcentaje}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "porcent_precio4",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        ) : (
                            <Field
                                name="precio4"
                                component={renderCurrency}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "precio4",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        )}
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-12 form-group">
                        {nombres_precios ? (
                            <label htmlFor="precio5">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                {nombres_precios.nombre_precio5}
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio5Value
                                                    ? parseFloat(precio5Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        ) : (
                            <label htmlFor="precio5">
                                {conf_porcentaje_precio && (
                                    <span className="mr-2">%</span>
                                )}
                                Precio 5
                                {conf_porcentaje_precio && (
                                    <span className="ml-2 negro-dark2">
                                        (
                                        <RCurrency
                                            value={
                                                precio5Value
                                                    ? parseFloat(precio5Value)
                                                    : 0
                                            }
                                        />
                                        )
                                    </span>
                                )}
                            </label>
                        )}
                        {conf_porcentaje_precio ? (
                            <Field
                                name="porcent_precio5"
                                component={renderPorcentaje}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "porcent_precio5",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        ) : (
                            <Field
                                name="precio5"
                                component={renderCurrency}
                                decimalScale={2}
                                type="number"
                                className="form-control"
                                onChange={(event) => {
                                    setTimeout(() => {
                                        cambioPorcentajePrecio(
                                            "precio5",
                                            "FraccionCrear"
                                        );
                                    });
                                }}
                            />
                        )}
                    </div>

                </div>
            </AccordionItem>


            <AccordionItem id="precios-sucursal" title="Precios por sucursal">
                <div className="row row-fields">
                    <div className="col-12 col-md-12 col-lg-12 form-group">
                        <label>Precios por sucursal</label>
                        <FieldArray
                            name="precios_sucursal"
                            component={preciosSucursal}
                            sucursales={sucursales}
                            sucursal={sucursal}
                            changeSucursal={changeSucursal}
                            sucursal_activo={sucursal_activo}
                            changeSucursalActivo={changeSucursalActivo}
                            nombres_precios={nombres_precios}
                            conf_porcentaje_precio={conf_porcentaje_precio}
                            cambioPorcentajePrecio={cambioPorcentajePrecio}
                            precios_sucursalValue={precios_sucursalValue}
                            nombreFormulario="FraccionCrear"
                        />
                    </div>
                </div>
            </AccordionItem>


            <AccordionItem id="propiedades" title="Propiedades del producto">
                <div className="row row-fields">
                    {editCreateFraccion.arriba ? (
                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="capacidad_maxima_arriba">
                                {editCreateFraccion.arriba.nombre} tiene
                            </label>
                            <div className="container-custom-field-span">
                                <div className="flex3">
                                    <Field
                                        name="capacidad_maxima_arriba"
                                        component={renderField}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <strong className="span-txt-fraccion flex1">
                                    {nombreValue}
                                </strong>
                            </div>
                        </div>
                    ) : null}
                    {/* <div className="col-lg-6 col-md-6 col-sm-12">
                        </div> */}
                    {editCreateFraccion.abajo ? (
                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="capacidad_maxima_abajo">
                                {nombreValue} tiene
                            </label>
                            <div className="container-custom-field-span">
                                <div className="flex3">
                                    <Field
                                        name="capacidad_maxima_abajo"
                                        component={renderNumber}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <strong className="span-txt-fraccion flex1">
                                    {editCreateFraccion.abajo.nombre}
                                </strong>
                            </div>
                        </div>
                    ) : null}
                    {/* <div className="col-lg-6 col-md-6 col-sm-12">
                        </div> */}
                </div>

                <div className="w-100 text-muted small mb-2">
                    Define cómo se gestionará este producto dentro del sistema. Aquí puedes indicar si estará disponible para la venta, si llevará control de inventario y si deseas recibir alertas cuando las existencias sean bajas.
                </div>

                <div className="row row-fields">
                    <div className="col-md-6 mb-4">
                        <SettingToggle
                            name="vendible"
                            title="Vendible"
                            description="Aparecerá en el punto de venta."
                            videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272110/Vendible_kkanef.mp4"]}
                            onOpenModal={openVideoModal}
                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <SettingToggle
                            name="alertar"
                            title="Alerta"
                            description="Cuando el producto tiene pocas existencias el sistema mostrará una alerta"
                            videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272326/Alerta_nz7gpn.mp4"]}
                            onOpenModal={openVideoModal}
                        />
                    </div>
                    {Boolean(alertarValue) ? (
                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                            <label htmlFor="minimo_existencias">
                                Mínimo de existencia *
                            </label>
                            <Field
                                name="minimo_existencias"
                                component={renderField}
                                type="text"
                                className="form-control"
                            />
                        </div>
                    ) : null}

                    {videos && (
                <ModalVideo
                    videos={videos}
                    onClose={closeVideoModal}
                />
            )}
                </div>
            </AccordionItem>
        </form>

        
    );
};

const Form = (props) => {
    //  state
    const {
        fracciones,
        editCreateFraccion,
        nombreValue,
        opcionValue,
        alertarValue,
        sucursales,
        sucursal,
        sucursal_activo,
        nombres_precios,
        conf_porcentaje_precio,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
    } = props;

    //  bind
    const {
        handleSubmit,
        agregarNuevaFraccion,
        editarFraccion,
        onCloseModal,
        changeSucursal,
        changeSucursalActivo,
        cambioPorcentajePrecio,
    } = props;
    // console.log("PROPS FROM FRACCION: ",props)
    return (
        <div className="">
            <div className="modal-container">
                <div className="grid-titulo padding-15">
                    Fracción{" "}
                    {editCreateFraccion.arriba
                        ? `menor que ${editCreateFraccion.arriba.nombre}`
                        : editCreateFraccion.abajo
                        ? `mayor que ${editCreateFraccion.abajo.nombre}`
                        : ""}
                </div>
                <div className="modal-body padding-15 p-sm-0 pt-sm-1 pb-sm-1">
                    <DatosFraccion
                        initialValues={props.initialValues}
                        alertarValue={alertarValue}
                        nombreValue={nombreValue}
                        editCreateFraccion={editCreateFraccion}
                        sucursales={sucursales}
                        sucursal={sucursal}
                        sucursal_activo={sucursal_activo}
                        changeSucursal={changeSucursal}
                        changeSucursalActivo={changeSucursalActivo}
                        nombres_precios={nombres_precios}
                        precio2Value={precio2Value}
                        precio3Value={precio3Value}
                        precio4Value={precio4Value}
                        precio5Value={precio5Value}
                        conf_porcentaje_precio={conf_porcentaje_precio}
                        cambioPorcentajePrecio={cambioPorcentajePrecio}
                        precios_sucursalValue={precios_sucursalValue}
                        
                    />
                </div>
                {/* FOOTER */}
                <div className="d-flex justify-content-center flex-row modal-footer">
                    <button
                        className="btn btn-tertiary m-1 align-self-center"
                        type="button"
                        onClick={() => {
                            onCloseModal();
                        }}
                    >
                        <img src={icons.cancelar} alt="" />
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary m-1 align-self-center"
                        onClick={handleSubmit((valores) => {
                            let data = { ...estructuraDatos, ...valores };
                            if (editCreateFraccion.tipo === "edit") {
                                editarFraccion(data, onCloseModal);
                            } else {
                                agregarNuevaFraccion(data, onCloseModal);
                            }
                        })}
                    >
                        <img src={icons.save} alt="" /> Guardar
                    </button>
                </div>
            </div>
        </div>
    );
};

let ProdFraccionForm = reduxForm({
    // a unique name for the form
    form: "FraccionCrear",
    validate,
})(Form);

//  Decorador para leer los valores del form
const selector = formValueSelector("FraccionCrear");

ProdFraccionForm = connect((state) => {
    const nombreValue = selector(state, "nombre");
    const opcionValue = selector(state, "opcion");
    const alertarValue = selector(state, "alertar");
    //  PRECIOS
    const precio2Value = selector(state, "precio2");
    const precio3Value = selector(state, "precio3");
    const precio4Value = selector(state, "precio4");
    const precio5Value = selector(state, "precio5");
    const precios_sucursalValue = selector(state, "precios_sucursal");
    return {
        nombreValue,
        opcionValue,
        alertarValue,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
        initialValues: {
            vendible: true,
            alertar: false,
            precios_sucursal: [],
        },
    };
})(ProdFraccionForm);

export default ProdFraccionForm;